// tslint:disable-next-line: no-submodule-imports
import DOMPurify from 'dompurify';
// tslint:disable-next-line: no-submodule-imports
import useStyles from 'isomorphic-style-loader/useStyles';
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { WINDOW_SIZE_ENUM } from '../types/IWindowSize';
import { UPDATE_TEXT_INPUT } from '../actions/Dialog';
import Dropdown from '../components/Dropdown';
import MultiselectList from '../components/MultiselectList';
import { LoadingSpinner } from '../components/LoadingSpinner';
import HorizontalItem from '../components/widgets/items/HorizontalItem';
import ImageRow from '../components/widgets/items/ImageRow';
import TextWithLink from '../components/widgets/items/TextWithLink';
import { IMAGE_DIALOG_BUTTON_ELEMENT, PRIMARY_DIALOG_BUTTON_ELEMENT, } from '../types/templates/dialog/ISkyfireDialogButtonElement';
import { dispatchSkyfireMethods, globals } from '../utils';
import { useObserver } from '../utils/ObserverHooks';
import * as Styles from './Dialog.scss';
import DialogColumn from './DialogColumn';
const { window } = globals;
export default function Dialog(props) {
    var _a, _b, _c, _d;
    useStyles(Styles);
    const { windowWidth } = useSelector((state) => state.BrowserState);
    const dispatch = useDispatch();
    const { closeButton, onViewed, header, body, buttons, columns, image, comfortText, subHeader, footer, selectorItems, multiSelectorItems, selectorDefault, textInputHeader, textInputDefault, textInputPlaceholder, textInputMaxLengthErrorMessage, textInputMaxLength, rowItemElementList, horizontalItem, primaryActionButton, secondaryActionButtons, } = props.template;
    useEffect(() => {
        window.addEventListener('keydown', handleEscape);
        window.addEventListener('popstate', handleBack);
        window.addEventListener('keydown', handleEnter);
        dispatchSkyfireMethods(dispatch, props.template, onViewed);
        return () => {
            window.removeEventListener('keydown', handleEscape);
            window.removeEventListener('popstate', handleBack);
            window.removeEventListener('keydown', handleEnter);
        };
    }, []);
    const inputRef = useRef(null);
    useEffect(() => { var _a, _b; return (_b = (_a = inputRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus(); }, []);
    const { displayLanguageId } = useSelector((state) => state.Authentication);
    const [optionId, updateOptionId] = useState(displayLanguageId);
    const textInputDefaultElement = useObserver(textInputDefault);
    const [textInput, setTextInput] = useState(((_a = textInputDefaultElement) === null || _a === void 0 ? void 0 : _a.text) || '');
    const onTextInputChange = (e) => setTextInput(e.target.value);
    const isTextInputMaxLengthReached = textInput.length === textInputMaxLength;
    const noop = () => true;
    if (!header && !body && !rowItemElementList) {
        return React.createElement(LoadingSpinner, null);
    }
    return (React.createElement("div", { className: Styles.modal, role: "dialog", "aria-modal": "true", "aria-labelledby": "dialogHeader", "aria-describedby": "dialogBodyText", id: "dialog" },
        React.createElement("div", { className: Styles.modalContent },
            renderCloseButton(),
            image && React.createElement("music-icon", { name: image, size: "large" }),
            header && (React.createElement("h1", { className: ['music-headline-4', Styles.header].join(' '), id: "dialogHeader" }, header)),
            subHeader && React.createElement("h1", { className: "music-headline-4" }, subHeader),
            React.createElement("div", { className: Styles.bodyTextContainer },
                body && (React.createElement("p", { className: "music-primary-text", id: "dialogBodyText" }, (_b = body.text, (_b !== null && _b !== void 0 ? _b : (_c = body.textWithLinks) === null || _c === void 0 ? void 0 : _c.map((textWithLinkElement) => (React.createElement(TextWithLink, { data: textWithLinkElement, template: props.template }))))) ||
                    body)),
                horizontalItem && (React.createElement(HorizontalItem, { data: horizontalItem, handleSelected: noop }))),
            multiSelectorItems && (React.createElement(MultiselectList, { template: props.template, items: multiSelectorItems })),
            selectorItems && (React.createElement(Dropdown, { options: selectorItems, currentOption: optionId, updateOption: updateOptionId, defaultValue: selectorDefault })),
            textInputHeader && (React.createElement("div", { className: Styles.textInputContainer },
                React.createElement("p", { className: "music-secondary-text" }, textInputHeader),
                isTextInputMaxLengthReached && (React.createElement("p", { className: [
                        Styles.textInputMaxLengthErrorMessage,
                        'music-secondary-text',
                    ].join(' ') }, textInputMaxLengthErrorMessage)),
                React.createElement("input", { ref: inputRef, className: [
                        Styles.textInput,
                        isTextInputMaxLengthReached
                            ? Styles.textInputMaxLengthErrorOutline
                            : '',
                    ].join(' '), placeholder: textInputPlaceholder, maxLength: textInputMaxLength, value: textInput, disabled: (_d = textInputDefaultElement) === null || _d === void 0 ? void 0 : _d.disabled, onChange: onTextInputChange }))),
            renderRowItemElementList(),
            renderColumns(),
            renderButtons(buttons),
            renderActionButtons(primaryActionButton, secondaryActionButtons),
            React.createElement("p", { className: "music-tertiary-text" }, comfortText),
            renderFooter())));
    function renderRowItemElementList() {
        if (!rowItemElementList) {
            return null;
        }
        return (React.createElement("div", { className: Styles.rowItemElementListsContainer }, rowItemElementList.map((rowItemElement) => {
            return (React.createElement("div", { className: Styles.rowItemElementListContainer },
                React.createElement("div", { className: Styles.rowItemElementListHeaderButtonContainer },
                    React.createElement("h3", null, rowItemElement.header),
                    rowItemElement.button &&
                        renderButton(rowItemElement.button, 'small', 0)),
                renderVisualRowItemElementList(rowItemElement.visualRowItemElementList)));
        })));
    }
    function renderVisualRowItemElementList(visualRowItemElementList) {
        return visualRowItemElementList.map((visualRowItemElement, index) => {
            return (React.createElement(ImageRow, { template: props.template, disableSelection: true, disableSecondaryTextInline: true, key: index, data: visualRowItemElement, handleSelected: handleSelected }));
        });
    }
    function onSubmit(isDisabled, onItemSelected, e) {
        var _a, _b, _c, _d, _e;
        if (isDisabled) {
            (_a = e) === null || _a === void 0 ? void 0 : _a.preventDefault();
            (_e = (_c = (_b = e) === null || _b === void 0 ? void 0 : _b.detail) === null || _c === void 0 ? void 0 : (_d = _c).preventDefault) === null || _e === void 0 ? void 0 : _e.call(_d);
            return;
        }
        dispatch({ type: UPDATE_TEXT_INPUT, payload: { textInput } });
        handleSelected(onItemSelected, e);
    }
    function handleSelected(onItemSelected, e) {
        var _a, _b, _c, _d, _e;
        (_a = e) === null || _a === void 0 ? void 0 : _a.preventDefault();
        (_e = (_c = (_b = e) === null || _b === void 0 ? void 0 : _b.detail) === null || _c === void 0 ? void 0 : (_d = _c).preventDefault) === null || _e === void 0 ? void 0 : _e.call(_d);
        if (selectorItems) {
            dispatch({
                type: 'CHANGE_DISPLAY_LANGUAGE',
                payload: {
                    displayLanguageId: optionId,
                },
            });
        }
        dispatchSkyfireMethods(dispatch, props.template, onItemSelected);
    }
    function handleEnter(e) {
        if (closeButton && e.keyCode === 13 && columns) {
            handleSelected(closeButton.primaryLink.onItemSelected, e);
        }
    }
    function handleEscape(e) {
        if (closeButton && e.keyCode === 27) {
            handleSelected(closeButton.primaryLink.onItemSelected, e);
        }
    }
    function handleBack(e) {
        if (closeButton) {
            handleSelected(closeButton.primaryLink.onItemSelected, e);
            e.preventDefault();
            // Since we can't actually cancel this event, we put the URL back to what it was
            // before anyone notices it has changed
            history.go(1);
        }
    }
    function renderActionButtons(actionButton, actionButtons) {
        if (!actionButton) {
            return null;
        }
        return (React.createElement("div", { className: Styles.buttonControls },
            (actionButtons || []).map((btn) => (React.createElement("music-button", { role: "button", variant: "glass", size: "small", "icon-only": true, "icon-name": btn.icon, onmusicActivate: handleSelected.bind(null, btn.primaryLink.onItemSelected) }, btn.text))),
            React.createElement("music-button", { role: "button", variant: "glass", size: windowWidth <= WINDOW_SIZE_ENUM.MD ? 'small' : 'medium', iconOnly: windowWidth <= WINDOW_SIZE_ENUM.MD, "icon-name": actionButton.icon, onmusicActivate: handleSelected.bind(null, actionButton.primaryLink.onItemSelected) }, actionButton.text)));
    }
    function renderColumns() {
        if (columns) {
            const columnContainerContents = columns.map((column) => (React.createElement(DialogColumn, { id: props.template.id, template: column })));
            return React.createElement("div", { className: Styles.columnsContainer }, columnContainerContents);
        }
    }
    function renderButtons(buttonsToRender) {
        if (!buttonsToRender || buttonsToRender.length === 0) {
            return null;
        }
        const buttonHasDescription = buttonsToRender.some((button) => button.description);
        const renderButtonFunction = buttonHasDescription
            ? renderButtonWithDescription
            : renderButton;
        const buttonContainerContents = buttonsToRender.length === 1
            ? renderButtonFunction(buttonsToRender[0], 'medium', 0)
            : buttonsToRender.map((button, idx) => renderButtonFunction(button, 'small', idx));
        return buttonHasDescription ? (React.createElement("div", { className: Styles.buttonContainerWithDescriptions }, buttonContainerContents)) : (React.createElement("div", { className: Styles.buttonContainer }, buttonContainerContents));
    }
    function renderButton(button, size = 'small', idx) {
        if (!button) {
            return null;
        }
        const isImageDialogButtonElement = button.interface === IMAGE_DIALOG_BUTTON_ELEMENT;
        const isPrimaryDialogButtonElement = button.interface === PRIMARY_DIALOG_BUTTON_ELEMENT;
        const isDisabled = isPrimaryDialogButtonElement && !!textInputHeader && textInput.trim().length === 0;
        const onmusicActivate = (e) => onSubmit(isDisabled, button.primaryLink.onItemSelected, e);
        const variant = isPrimaryDialogButtonElement
            ? 'solid'
            : isImageDialogButtonElement
                ? 'image'
                : 'outline';
        return (React.createElement("music-button", { id: `dialogButton${idx + 1}`, variant: variant, disabled: isDisabled, "icon-name": button.icon, image: button.image, href: button.primaryLink.deeplink, tabIndex: 3, size: size, onmusicActivate: onmusicActivate }, button.text));
    }
    function renderButtonWithDescription(button, size = 'small', idx) {
        return (button && (React.createElement(Fragment, null,
            renderButton(button, size, idx),
            React.createElement("div", { className: "music-tertiary-text" }, button.description))));
    }
    function renderCloseButton() {
        if (!closeButton) {
            return null;
        }
        return (React.createElement("div", { className: Styles.closeButtonContainer, id: "dialogCloseButton" },
            React.createElement("music-button", { role: "button", variant: "glass", size: "small", "icon-only": true, "icon-name": closeButton.icon, tabIndex: 3, onmusicActivate: handleSelected.bind(this, closeButton.primaryLink.onItemSelected) })));
    }
    function renderFooter() {
        var _a;
        if (!footer) {
            return null;
        }
        let handleFooterLinkClicked = () => {
            return;
        };
        if ((_a = footer.primaryLink) === null || _a === void 0 ? void 0 : _a.onItemSelected) {
            handleFooterLinkClicked = () => { var _a; return handleSelected(((_a = footer.primaryLink) === null || _a === void 0 ? void 0 : _a.onItemSelected) || []); };
        }
        return (React.createElement("div", { className: ['music-tertiary-text', Styles.footerContent].join(' ') },
            renderHTML(footer.styledText),
            footer.primaryLink && footer.primaryText && (React.createElement("div", { className: Styles.footerLink },
                React.createElement("music-link", { kind: "accent", onClick: handleFooterLinkClicked }, footer.primaryText))),
            React.createElement("div", { className: Styles.footerSecondaryText }, renderHTML(footer.secondaryText))));
    }
    function renderHTML(text) {
        const newText = (text || '')
            .replace(/<a/g, '<music-link kind="accent"')
            .replace(/<\/a>/g, '</music-link>');
        const config = {
            ADD_TAGS: ['MUSIC-LINK'],
            ADD_ATTR: ['kind', 'target'],
        };
        return React.createElement("div", { dangerouslySetInnerHTML: { __html: DOMPurify.sanitize(newText, config) } });
    }
}
